import { createContext, useContext, useEffect, useState } from "react";
import useViewData from "features/view/hooks/useViewData";
import { useHistory, useLocation } from "react-router-dom";
import Session from "utils/Session";

const ViewContext = createContext({});

export const ViewContextProvider = ({ name, children }) => {
  const [ queryString, setQueryString ] = useState();
  const [ refreshToken, setRefreshToken ] = useState(null);
  const [ showMobileFilters, setShowMobileFilters ] = useState();
  const history = useHistory();
  const location = useLocation();

  const refresh = () => {
    setRefreshToken(Math.random());
  }

  const hasFilters = () => {
    if (queryString) {
      const searchParams = new URLSearchParams(queryString);

      const hasLocationFilter = searchParams.get('location[distance][from]');
      const hasTermFilter = searchParams.has('search');
      const hasFacetFilter = searchParams.has('f[0]');

      return hasFacetFilter || hasTermFilter || hasLocationFilter;
    } else {
      return false;
    }
  }

  const clearFilters = () => {
    history.push('?');
  }

  const { view, isLoading } = useViewData(name, queryString, refreshToken);

  // On refresh, load the query string from the url.
  useEffect(
    () => {
      setQueryString(location.search);
      Session.save(location.pathname, 'query', location.search);
    },
    [ location ]);

  // Store the scroll position in the session when clicking a teaser, or clear it when
  // clicking anything else
  useEffect(
    () => {
      const clickHandler = (event) => {
        const teasers = document.querySelector('.teaser');
        const teaserContainer = teasers?.parentElement;
        if (!teaserContainer) {
          return;
        }

        let scrollPos = null;
        if (teaserContainer.contains(event.target)) {
          scrollPos = window.scrollY;
        }

        Session.save(location.pathname, 'scrollY', scrollPos);
      };
      window.addEventListener('mousedown', clickHandler);

      return () => {
        window.removeEventListener('mousedown', clickHandler);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

  // When the view is done loading, jump to the last known Y position
  useEffect(
    () => {
      const y = Session.load(location.pathname, 'scrollY');
      if (!isLoading && y) {
        window.scrollTo(0, y);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ isLoading ]);

  return (
    <ViewContext.Provider value={ {
      view,
      isLoading,
      setQueryString,
      showMobileFilters,
      setShowMobileFilters,
      refresh,
      hasFilters,
      clearFilters
    } }>
      { children }
    </ViewContext.Provider>
  )
}

export function useView() {
  return useContext(ViewContext);
}

export default ViewContextProvider;
